import { render, staticRenderFns } from "./FluxButton.vue?vue&type=template&id=b4c731a6&"
import script from "./FluxButton.vue?vue&type=script&lang=js&"
export * from "./FluxButton.vue?vue&type=script&lang=js&"
import style0 from "./FluxButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports